import React from "react";
import KeywordsTag from './KeywordsTag';

const Water = ({ yearsIsVisible, monthsIsVisible, keywordsIsVisible }) => (
    <KeywordsTag
        tagId="waterPublic"
        handwritingSrc="../../content/handwriting/water.png"
        handwritingAlt="water"
        yearsIsVisible={yearsIsVisible}
        monthsIsVisible={monthsIsVisible}
        keywordsIsVisible={keywordsIsVisible}
    />
);

export default Water;